import http from './HttpService';
import { API_BASE_CAMPAIGN, API_BASE_ASSET, API_BASE_ANALYTICS } from '../../constants/index';
import { ICreateAssetResponse } from '../Campaigns/interfaces';
import axios from 'axios';
import { editSubjectAIEmailEvents, personalities } from 'modules/Campaigns/utils';
import { convertEmojisInStringToUnicode } from 'utils';

let cancelTokenOverview: any;
export async function getCampaignsListService(queryParams: any) {
  let url = `${API_BASE_CAMPAIGN}get_campaigns/?limit=${queryParams.limit}&offset=${queryParams.offset}`;

  if (queryParams.user_id) url += `&user_id=${queryParams.user_id}`;
  if (queryParams.email_type !== undefined) url += `&email_type=${queryParams.email_type}`;
  if (queryParams.search_campaign) url += `&search_campaign=${encodeURIComponent(queryParams.search_campaign)}`;
  // if (queryParams.start_date && queryParams.end_date)
  //   url += `&start_date=${queryParams.start_date}&end_date=${queryParams.end_date}`;

  //Check if there are any previous pending requests
  if (typeof cancelTokenOverview != typeof undefined) {
    cancelTokenOverview && cancelTokenOverview.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenOverview = axios.CancelToken.source();

  return await http.get(url, {
    cancelToken: cancelTokenOverview.token,
  });
}

let cancelTokenCampaignsNamesOnly: any;
export async function getCampaignsNamesOnlyService(params: any) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenCampaignsNamesOnly != typeof undefined) {
    cancelTokenCampaignsNamesOnly && cancelTokenCampaignsNamesOnly.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenCampaignsNamesOnly = axios.CancelToken.source();
  return await http.get(`${API_BASE_CAMPAIGN}get_campaigns/?list_only=1${params ? '&' + params : ''}`, {
    cancelToken: cancelTokenCampaignsNamesOnly.token,
  });
}

export async function deleteCampaignService(campaignId: string) {
  var formData = new FormData();
  formData.append('campaign_id', campaignId);
  return await http.post(`${API_BASE_CAMPAIGN}delete_campaign/`, formData, {});
}

export async function updateCampaignNameService(
  campaignId: string,
  campaignName: string,
  campaignSubject: string = '',
) {
  var formData = new FormData();
  formData.append('campaign_id', campaignId);
  formData.append('name', campaignName);
  // if (campaignSubject) formData.append("subject", campaignSubject);
  return await http.post(`${API_BASE_CAMPAIGN}update_campaign/`, formData, {});
}
let cancelTokenCampaignData: any;
export async function getCampaignDataService(campaignId: string) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenCampaignData != typeof undefined) {
    cancelTokenCampaignData && cancelTokenCampaignData.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenCampaignData = axios.CancelToken.source();

  return await http.get(`${API_BASE_CAMPAIGN}campaign_details/${campaignId}/`, {
    cancelToken: cancelTokenCampaignData.token,
  });
}

export async function deleteAssetService(assetId: string) {
  var formData = new FormData();
  formData.append('asset_id', assetId);
  return await http.post(`${API_BASE_CAMPAIGN}delete_asset/`, formData, {});
}

export async function createEmailService(
  email_name: string,
  campaign_id?: string,
  templateId?: number,
  email_id?: string,
  clone_only?: number,
  create_campaign?: number,
  campaign_name?: string,
  keywords?: any,
  contact_ids?: any,
  list_ids?: any,
) {
  const payload = new FormData();
  payload.append('email_name', email_name);
  if (email_id) payload.append('email_id', email_id);
  if (clone_only) payload.append('clone_only', clone_only.toString());
  if (campaign_id) payload.append('campaign_id', campaign_id);
  if (templateId) payload.append('template_id', templateId.toString());
  if (create_campaign) payload.append('create_campaign_flag', create_campaign.toString());
  if (campaign_name) payload.append('campaign_name', campaign_name);

  if (keywords && keywords?.length > 0) for (let kw of keywords) payload.append('keywords', kw);
  if (contact_ids && contact_ids?.length > 0) for (let ci of contact_ids) payload.append('contact_ids', ci);
  if (list_ids && list_ids?.length > 0) for (let li of list_ids) payload.append('list_ids', li);

  return await http.post<any>(`${API_BASE_CAMPAIGN}create_email/`, payload, {});
}

export async function createAssetAndCampaignService(
  asset_name: string,
  campaign_name: string,
  keywords?: string[],
  contact_ids?: any[],
  list_ids?: any[],
  templateId?: number,
  email_id?: number,
) {
  const payload = new FormData();
  payload.append('email_name', asset_name);
  if (email_id) payload.append('email_id ', email_id.toString());
  payload.append('campaign_name ', campaign_name);
  payload.append('create_campaign_flag', '1');
  if (keywords) {
    for (let kw of keywords) payload.append('keywords', kw);
  }
  if (contact_ids) {
    for (let ci of contact_ids) payload.append('contact_ids', ci);
  }
  if (list_ids) {
    for (let li of list_ids) payload.append('list_ids', li);
  }
  if (templateId) payload.append('template_id', templateId.toString());

  return await http.post(`${API_BASE_CAMPAIGN}create_email/`, payload, {});
}

export async function getAIEmailService(generationId: string) {
  return await http.get(`${API_BASE_CAMPAIGN}get_ai_emails/?generation_id=${generationId}`, {});
}

export async function setAIEmailReviewService(emailId: string, isVisited: boolean, generationId: string) {
  const payload = new FormData();
  payload.append('email_id', emailId);
  if (isVisited) payload.append('is_reviewed', '1');
  payload.append('last_visited', '1');
  payload.append('generation_id', generationId);
  return await http.post(`${API_BASE_CAMPAIGN}review_ai_emails/`, payload, {});
}

export async function saveAsDraftAiEmailService(
  generationId: string,
  emailName?: string,
  campaignId?: string,
  campaignName?: string,
  eventType?: string,
) {
  const payload = new FormData();
  payload.append('generation_id', generationId);
  if (emailName) {
    payload.append('version_name', emailName);
  }
  if (campaignName) {
    payload.append('campaign_name', campaignName);
  }
  if (campaignId && !campaignName) {
    payload.append('campaign_id', campaignId.toString());
  }
  if (eventType) payload.append('event_type', eventType);
  return await http.post(`${API_BASE_CAMPAIGN}clone_ai_email/`, payload, {});
}

export async function createAIEmailAndCampaignService(
  emailName: string,
  campaignName: string,
  campaignId: number,
  prompt: string,
  eventType?: string,
  contact_ids?: any[],
  list_ids?: any[],
  generationId?: string,
  personalities?: Array<personalities>,
  sendToEmails?: string[],
) {
  const payload = new FormData();
  payload.append('email_name', emailName);
  if (campaignName) {
    payload.append('campaign_name', campaignName);
  }
  if (campaignId && !campaignName) {
    payload.append('campaign_id', campaignId.toString());
  }
  payload.append('prompt', prompt);
  if (campaignName) {
    payload.append('create_campaign_flag', '1');
  } else {
    payload.append('create_campaign_flag', '0');
  }
  if (contact_ids?.length) {
    payload.append('contact_ids', contact_ids.join(','));
  }
  if (list_ids?.length) {
    payload.append('list_ids', list_ids.join(','));
  }
  if (personalities?.length) {
    payload.append('personalities', personalities.map((p) => p.charAt(0)).join(','));
  }
  if (generationId) {
    payload.append('ai_id', generationId);
  }
  if (eventType) {
    payload.append('event_type', eventType);
  }
  if (sendToEmails?.length) {
    payload.append('emails_to', sendToEmails.join(','));
  }

  return await http.post(`${API_BASE_CAMPAIGN}create_ai_email/`, payload, {
    timeout: 300000,
  });
}

export async function updateAssetService(
  email_name: string,
  email_id: string,
  campaign_id?: string,
  isSubject?: boolean,
  aiType?: personalities,
) {
  const payload = new FormData();
  if (isSubject) payload.append('subject', convertEmojisInStringToUnicode(email_name));
  else payload.append('email_name', email_name);
  payload.append('email_id', email_id);
  if (campaign_id) payload.append('campaign_id', campaign_id);
  if (aiType) payload.append('evnent_type', editSubjectAIEmailEvents[aiType]);
  return await http.post<ICreateAssetResponse>(`${API_BASE_CAMPAIGN}update_email/`, payload, {});
}

export async function updateAssetAndCampaignService({
  asset_id,
  asset_name = '',
  campaign_name = '',
  keywords = [],
  contact_ids = [],
  list_ids = [],
  subject = '',
  eventType = '',
}: {
  asset_id: string;
  campaign_name?: string;
  keywords?: string[];
  contact_ids?: any[];
  list_ids?: any[];
  asset_name?: string;
  subject?: string;
  eventType?: string;
}) {
  const payload = new FormData();
  payload.append('email_id', asset_id.toString());
  if (campaign_name) {
    payload.append('campaign_name', campaign_name);
  }
  if (campaign_name) {
    payload.append('create_campaign_flag', '1');
  }
  if (subject) {
    payload.append('subject', convertEmojisInStringToUnicode(subject));
  }
  if (asset_name) {
    payload.append('email_name', asset_name);
  }
  if (keywords?.length) {
    for (let kw of keywords) payload.append('keywords', kw);
  }
  if (contact_ids?.length) {
    for (let ci of contact_ids) payload.append('contact_ids', ci);
  }
  if (list_ids?.length) {
    for (let li of list_ids) payload.append('list_ids', li);
  }
  if (eventType) payload.append('event_type', eventType);

  return await http.post(`${API_BASE_CAMPAIGN}update_email/`, payload, {});
}

export async function createNewDraftEdtionCampaignService(assetId: any) {
  const payload = new FormData();
  payload.append('asset_id', assetId);
  return await http.post<any>(`${API_BASE_CAMPAIGN}create_edition/`, payload, {});
}
export async function saveSentAsDraftEditionCampaignService(assetId: any, versionId: any) {
  const payload = new FormData();
  // payload.append("asset_id", assetId);
  payload.append('email_id', versionId);
  return await http.post<any>(`${API_BASE_CAMPAIGN}create_email/`, payload, {});
}

export async function getAssetService(campaignId: any) {
  return await http.get(`${API_BASE_CAMPAIGN}get_draft_emails/${campaignId}/?limit=50&offset=0`, {});
}

/* articles in previously sent assets */
export async function digestPreviouslySent(queryParams: any) {
  return await http.get(`${API_BASE_CAMPAIGN}previously_sent_articles/?${queryParams}`, {});
}

export async function getAssetGraphDataService(campaignId: any, queryParams: any) {
  return await http.get(`${API_BASE_ANALYTICS}assets_analytics/${campaignId}/?${queryParams}`, {});
}

export async function getVersionGraphDataService(assetId: any) {
  return await http.get(`${API_BASE_ANALYTICS}versions_analytics/${assetId}/`, {});
}
export async function getCampaignsDashboardGraphDataService(_params: any) {
  let url = `${API_BASE_ANALYTICS}campaigns_analytics/?start_date=${_params.start_date}&end_date=${_params.end_date}`;
  if (_params?.user_id && _params?.user_id !== 'default') url += `&user_id=${_params.user_id}`;
  if (_params.campaign_id) url += `&campaign_ids=${_params.campaign_id}`;
  return await http.get(url);
}

export async function createCampaignService(
  name: string,
  keywrods: Array<string>,
  contactIds: Array<number>,
  listIds: Array<number>,
  advancedFilter?: boolean,
  sourcedContent?: Array<any>,
  excludedContent?: Array<any>,
  excludedKeywords?: Array<string>,
  includedKeywords?: Array<string>,
) {
  const payload = new FormData();
  payload.append('campaign_name', name);
  for (let item of keywrods) {
    payload.append('keywords', item);
  }
  for (let item of contactIds) {
    payload.append('contact_ids', item.toString());
  }
  for (let item of listIds) {
    payload.append('list_ids', item.toString());
  }
  if (advancedFilter) {
    payload.append('advanced_search', advancedFilter.toString());
  }
  if (sourcedContent) {
    for (let item of sourcedContent) {
      payload.append('include_sources', JSON.stringify(item));
    }
  }
  if (excludedContent) {
    for (let item of excludedContent) {
      payload.append('exclude_sources', JSON.stringify(item));
    }
  }
  if (excludedKeywords) {
    for (let item of excludedKeywords) {
      payload.append('exclude_keywords', item.toString());
    }
  }
  if (includedKeywords) {
    for (let item of includedKeywords) {
      payload.append('include_keywords', item.toString());
    }
  }
  return await http.post(`${API_BASE_CAMPAIGN}create_campaign/`, payload, {});
}

export async function getUsersDataFilterService(queryParams: string = '') {
  return await http.get(`${API_BASE_CAMPAIGN}get_users/${queryParams ? '?' + queryParams : ''}`, {});
}

export async function getAssetsService(queryParams: string) {
  return await http.get(`${API_BASE_ASSET}get_assets/?${queryParams}`, {});
}

export async function getEmailsWithoutCampaignListService() {
  return await http.get(`${API_BASE_CAMPAIGN}get_emails_without_campaign/`);
}

export async function cloneCampaignService(campaign_id: number) {
  const payload = new FormData();
  return await http.post(`${API_BASE_CAMPAIGN}clone_campaign/${campaign_id}/`, payload, {});
}

export const detectNewPersonality = async (
  contactIds: Array<number>,
  listIds: Array<number>,
  personalities: Array<personalities>,
  generationId: string,
) => {
  const payload = new FormData();
  if (contactIds.length) payload.append('contact_ids', contactIds.join(','));
  if (listIds.length) payload.append('list_ids', listIds.join(','));
  if (personalities.length) payload.append('personalities', personalities.map((p) => p.charAt(0)).join(','));
  if (generationId) payload.append('generation_id', generationId);
  return await http.post(`${API_BASE_CAMPAIGN}detect_new_personality/`, payload, {});
};

export const changeAIEmailTemplateService = (payload: any) => {
  return http.post(`${API_BASE_CAMPAIGN}change_ai_email_template/`, payload, {});
};
